<template>
    <div class="usracc position-fixed" style="width: 100%;">
        <BHeader :title="$t('common.usracc')" :isLogin="true" back="/usr_top" :isInUserAccount="true"/>
        <div class="card-wrapper">
            <BCard no-body class="usrpro-card">
                <div class="card-text-1" style="margin-top: 8px;">{{$t("usracc.loginId")}}</div>
                <div class="card-text-2">{{loginId}}</div>
                <div class="card-text-1">{{$t("usracc.usrNm")}}（{{$t("usracc.usrNmKna")}}）</div>
                <div class="card-text-2">{{usrNm}}<div v-if="usrNmKna != ''">（{{usrNmKna}}）</div></div>
            </BCard>
        </div>

        <div class="set">
            <div class="set-text">{{$t("usracc.setting")}}</div>
            <div class="set-inline" @click="goUsrPro">
                <div class="inner-inline">
                    <BImg :src="set1" alt="set1" class="set-img"></BImg>
                    <div class="text">{{$t("usracc.usrpro")}}</div>
                </div>
                <BImg :src="arrowForward" alt="arrowForward"></BImg>
            </div>
            <div class="outline"></div>
            <div class="set-inline" @click="goUsrPas">
                <div class="inner-inline">
                    <BImg :src="set2" alt="set2" class="set-img"></BImg>
                    <div class="text">{{$t("usracc.password_edit")}}</div>
                </div>
                <BImg :src="arrowForward" alt="arrowForward"></BImg>
            </div>
            <div class="outline"></div>
            <div class="set-inline" @click="goLanguage">
                <div class="inner-inline">
                    <BImg :src="set3" alt="set3" class="set-img"></BImg>
                    <div class="text">{{$t('usracc.language_edit')}}</div>
                </div>
                <BImg :src="arrowForward" alt="arrowForward"></BImg>
            </div>
            <div class="outline"></div>
          <div class="set-inline" @click="goNotice">
            <div class="inner-inline">
              <BImg :src="set5" alt="set4" class="set-img"></BImg>
              <div class="text">{{$t('notice.title')}}</div>
            </div>
            <BImg :src="arrowForward" alt="arrowForward"></BImg>
          </div>
          <div class="outline"></div>

        </div>

        <div class="operate">
            <div class="operate-text">{{$t("usracc.operation")}}</div>
            <BButton @click="logout()" class="operate-button-text">{{$t("usracc.logout")}}</BButton>
        </div>
        <BFooter whichPage="1" />
    </div>
</template>

<script>
import BHeader from '@/views/header.vue'
import BFooter from '@/views/footer.vue'
import { useRouter } from 'vue-router'
import { acc } from '../usracc/acc.js'
import { ref,inject } from 'vue'
import { removeToken } from '@/utils/CookieUtils'
import { cryptoEffect } from '@/utils/cryptoUtil'
export default {
    name: 'usracc',
    components: {
        BHeader,
        BFooter,
    },
    setup () {
        gtag('event', 'viewAccountManage', {
            'event_name': 'view'
        })
        const {encrypt, decrypt} = cryptoEffect()
        const router = useRouter()
        const loginId = ref('')
        const usrNm = ref('')
        const usrNmKna = ref('')
        const service = inject("service")
        const isJcc = sessionStorage.getItem("isJcc")

        function goUsrPro () {
            router.push('/usrpro')
        }
        function goUsrPas () {
            router.push('/usrpas')
        }
        function goLanguage () {
            router.push('/language')
        }
        function goNotice () {
            router.push('/notice')
        }
        acc().then(res => {
            loginId.value = res.data.loginId;
            usrNm.value = res.data.usrNm;
            usrNmKna.value = res.data.usrNmKna
        })

        function logout(){
            gtag('event', 'tapLogoutButton', {
                'event_name': 'tap'
            })
            removeToken()
          let fcmToken = localStorage.getItem('fcmToken')
          let formData = {}
          if (fcmToken != null) {
            formData = {
              fcmToken: fcmToken
            }
          }
            service.login.logout(formData).then(res=>{
                if (res.fromRismonFlag == 1) {
                    if (res.isJcc) {
                        window.location = '/smt/jcclogin'
                    } else {
                        window.location = '/smt/login'
                    }
                } else if (res.fromRismonFlag == 2) {
                    if (res.isJcc) {
                        window.location = '/smt/jcclogin/' + res.comid
                    } else {
                        window.location = '/smt/login/' + res.comid
                    }
                } else {
                    window.location = '/smt/login'
                }
            }).catch(error => {
                console.log(error)
            })
            sessionStorage.clear()
            var temp = JSON.parse(decrypt(localStorage.getItem('session_timeout')))
            temp.isSaveLoginInfo =  0
            temp.password = ''
            localStorage.setItem('session_timeout', encrypt(JSON.stringify(temp)))
        }

        return {
            loginId,
            usrNm,
            usrNmKna,
            set1: require('@/assets/icon/set1.svg'),
            set2: require('@/assets/icon/set2.svg'),
            set3: require('@/assets/icon/set3.svg'),
            set4: require('@/assets/icon/set4.svg'),
            set5: require('@/assets/icon/set5.svg'),
            arrowForward: require('@/assets/icon/arrow_forward_ios.svg'),
            logout,
            goUsrPro,
            goUsrPas,
            goLanguage,
            goNotice
        }
    },
}
</script>

<style lang="scss" scoped>
    .usracc{
        padding: 56px 0px 56px;
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar{
            display: none;
        }
        .card-wrapper{
            padding: 0px 16px;
            .usrpro-card{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                padding: 16px;
                width: 100%;
                height: 154px;
                background: #EEF1F3;
                border-radius: 4px;
                flex: none;
                order: 1;
                align-self: stretch;
                flex-grow: 0;

                .card-text-1{
                    height: 18px;
                    margin-bottom: 2px;
                    font-family: 'Hiragino Kaku Gothic ProN';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 18px;
                    display: flex;
                    align-items: center;
                    color: #8B949E;
                }
                .card-text-2{
                    height: 21px;
                    margin-bottom: 24px;
                    font-family: 'SF Pro';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 21px;
                    display: flex;
                    align-items: center;
                    letter-spacing: 0.01em;
                    color: #30353B;
                }
            }
        }

        .set{
            padding: 0px 16px;
            .set-text{
                margin-top: 32px;
                margin-bottom: 8px;
                height: 18px;
                font-family: 'Hiragino Kaku Gothic ProN';
                font-style: normal;
                font-weight: 600;
                font-size: 13px;
                line-height: 18px;
                display: flex;
                align-items: center;
                color: #8B949E;
                flex: none;
                order: 0;
                flex-grow: 0;
            }
            .set-inline{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 56px;
                .inner-inline{
                    display: flex;
                    .text{
                        padding-top: 4px;
                        font-weight: 300;
                        font-size: 15px;
                        line-height: 20px;
                        color:#30353B;
                    }
                }
            }
            .set-img{
                margin-right: 8px;
                width: 24px;
                height: 24px;
            }
            .outline{
                margin-top: 4px;
                margin-bottom: 4px;
                width: 100%;
                height: 1px;
                background: #F3F7FD;
                flex: none;
                order: 1;
                flex-grow: 0;
            }
        }

        .operate{
            padding: 0px 16px;
            margin-top: 24px;

            :deep(.btn){
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 8px 16px;
                gap: 4px;
                font-weight: 600;
                font-size: 13px;
                line-height: 18px;
                width: 100%;
                height: 40px;
                background: #2394F7;
                border-radius: 4px;
                border-width: 0px;
            }
            .operate-text{
                height: 18px;
                margin-bottom: 8px;
                /* Hiragino 13B */

                font-family: 'Hiragino Kaku Gothic ProN';
                font-style: normal;
                font-weight: 600;
                font-size: 13px;
                line-height: 18px;
                /* identical to box height, or 138% */

                display: flex;
                align-items: center;

                /* 060 */

                color: #8B949E;


                /* Inside auto layout */

                flex: none;
                order: 0;
                flex-grow: 0;
            }
        }
    }
</style>
